var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo56X62(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 62,
    viewBox: "0 0 56 62",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.0068 53.5321C53.2119 52.6913 52.1493 52.1538 51.001 52.0123C49.8526 51.8707 48.6901 52.1339 47.7148 52.7564C46.7395 53.3789 46.0123 54.3218 45.6572 55.4229C45.3021 56.5241 45.3417 57.7146 45.7695 58.7896C46.1974 59.8646 46.9863 60.7568 48.001 61.3128C49.0156 61.8688 50.1928 62.0537 51.3291 61.8358C52.4654 61.6178 53.4905 61.0107 54.2275 60.1187C54.9645 59.2268 55.3674 58.1061 55.3672 56.9491C55.3808 55.6755 54.8918 54.4479 54.0068 53.5321Z",
    fill: "#54B4E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4946 9.48478L52.272 8.38493C51.9829 8.12304 51.6748 7.88302 51.3501 7.66691L50.0503 6.79997L49.8833 6.68376C48.5694 5.86785 47.213 5.12165 45.8208 4.44792L45.5015 4.28092C43.1578 3.13325 40.6762 2.29004 38.1187 1.77189C35.5769 1.19313 32.9727 0.93475 30.3667 1.00285C21.5807 1.00285 14.7666 3.9238 8.9126 10.2028C3.1836 16.4538 0.513184 23.726 0.513184 33.091C0.513184 42.091 2.60219 47.9528 7.97119 54.0028C12.9142 59.4638 19.381 61.8788 28.939 61.8568C30.329 61.8568 32.205 61.8568 33.939 61.8568H34.939C36.24 61.8568 37.4878 61.34 38.4077 60.4201C39.3277 59.5001 39.8442 58.2523 39.8442 56.9513C39.8442 55.6503 39.3277 54.4025 38.4077 53.4826C37.4878 52.5626 36.24 52.0458 34.939 52.0458H30.3862C30.3392 52.0458 30.2927 52.0458 30.2437 52.0458L29.7163 52.0168C26.4233 51.8348 23.3161 51.662 21.1851 50.717C19.1338 49.9083 17.2843 48.6608 15.7661 47.0619C11.6391 42.8059 10.8823 39.017 10.8823 33.091C10.8823 26.463 12.8685 20.8909 16.6265 16.9909L16.6489 16.9648C20.2209 13.0198 25.1849 11.0199 31.3999 11.0199C35.218 11.0861 38.9576 12.1152 42.272 14.0119C42.45 14.1119 42.6289 14.2119 42.8169 14.3119C43.72 14.7433 44.5639 15.2882 45.3286 15.9338V42.0339C45.331 43.3303 45.8457 44.5732 46.7603 45.4921C47.6748 46.411 48.916 46.9314 50.2124 46.9399H50.5542C51.2005 46.9436 51.8409 46.8193 52.439 46.5744C53.037 46.3295 53.5805 45.9688 54.0386 45.5129C54.4966 45.0569 54.8602 44.515 55.1079 43.9181C55.3556 43.3212 55.4826 42.6811 55.4819 42.0348V16.5448C55.4889 14.2738 55.4926 11.1818 53.4946 9.48478Z",
    fill: "url(#paint0_linear_1290_1297)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1290_1297",
    x1: 14.9702,
    y1: 59.2398,
    x2: 48.1373,
    y2: 6.14115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F437B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#0F437B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2C3C6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#862946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#BF1D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#D61923"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo56X62);
export default __webpack_public_path__ + "static/media/logo-56x62.acdac3037e3cf246299ddfce20271c99.svg";
export { ForwardRef as ReactComponent };